import React from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
const FormData = ({
    show,
    handleClose,
    formAttribute,
    handleChange,
    handleSubmit,
    isLoading,
    validate,
    dataList
}) => {
    const { title, data } = formAttribute;
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header className="bg-card-gradient light border-bottom-0">
                <Modal.Title className="text-white">{title}</Modal.Title>
                <FalconCloseButton onClick={handleClose} variant="white"/>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validate} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formGroupKode">
                        <Form.Label>Kode</Form.Label>
                        <Form.Control 
                            type="text" 
                            value={data?.vckode} 
                            onChange={(event) => handleChange(event)} 
                            name="vckode" 
                            placeholder="Kode"
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Kode tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupNama">
                        <Form.Label>Nama</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcnama}
                            onChange={(event) => handleChange(event)}
                            name="vcnama"
                            placeholder="Nama" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Nama tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupNomor Kendaraan">
                        <Form.Label>Nomor Kendaraan</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcnopol}
                            onChange={(event) => handleChange(event)}
                            name="vcnopol"
                            placeholder="Nomor Kendaraan" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Nomor Kendaraan tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupGender">
                        <Form.Label>Tipe Kendaraan</Form.Label>
                        <Form.Select value={data?.inttypeangkutan} onChange={(event) => handleChange(event)} name="inttypeangkutan" required>
                            <option value=''>Pilih Tipe Kendaraan</option>
                            <option value={1}>Bus</option>
                            <option value={2}>Angkotan</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            Tipe Kendaraan tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupGender">
                        <Form.Label>Rute</Form.Label>
                        <Form.Select value={data?.intrute_angkutan_id} onChange={(event) => handleChange(event)} name="intrute_angkutan_id" required>
                            <option value=''>Pilih Rute</option>
                            {
                                dataList.route ? dataList.route.map((value, index) => {
                                    return (
                                        <option value={value.value} key={index}>{value.label}</option>
                                    );
                                }) : ''
                            }
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            Rute tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
                    </Button>
                    <Button disabled={isLoading} type="submit" className="float-end">
                        {isLoading ? (<>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            Loading...
                        </>
                        ) : (<>
                            <FontAwesomeIcon icon={faSave} className="me-2" />
                            Simpan
                        </>) }
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

FormData.propTypes = {}

export default FormData;